import isNil from "lodash/isNil";

import { CardContent } from "./types.ts";

export const isCardContentEmpty = (content: CardContent): boolean => {
  return isNil(content) || content === "";
};
